export class Constants {
    public static readonly returnUrl: string = 'ReturnUrl';
    public static readonly defaultNotifyShowTime: number = 6000;

    public static readonly notifyWarning: string = 'warning';
    public static readonly notifySuccess: string = 'success';
    public static readonly notifyError: string = 'error';
}